import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = {
  "clip-path": "url(#clip0_738_50)"
};
const _hoisted_3 = ["fill"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [/*#__PURE__*/_createElementVNode("clipPath", {
  id: "clip0_738_50"
}, [/*#__PURE__*/_createElementVNode("rect", {
  width: "20",
  height: "20",
  fill: "white"
})])], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", {
    width: $props.width,
    height: $props.height,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [_createElementVNode("g", _hoisted_2, [_createElementVNode("path", {
    d: "M12.8416 6.175L11.6666 5L6.66663 10L11.6666 15L12.8416 13.825L9.02496 10L12.8416 6.175Z",
    fill: $props.color
  }, null, 8, _hoisted_3)]), _hoisted_4], 8, _hoisted_1);
}